import { Component, OnInit } from '@angular/core';
import * as _ from 'lodash';
import { EaGridkyService } from '../ea-gridky.service';

interface PropertyRating {
  fieldName: string;
  rating: number;
  description: string;
  title: string;
}
@Component({
    selector: 'ea-gridky-info',
    templateUrl: './ea-gridky-info.component.html',
    styleUrls: ['./ea-gridky-info.component.scss'],
    standalone: false
})
export class EaGridkyInfoComponent implements OnInit {
  mapOptions: google.maps.MapOptions;
  marker: any;
  darkMode: boolean;
  map;
  properties;
  _ = _;
  noteFieldNames = [
    'potentialCapitalGain',
    'resaleEasiness',
    'neighborhoodAttractivity',
    'rentProfitability',
    'rentalSecurity',
    'taxPerformance',
    'rentalProfitabilityPostConsolidation',
    'managerStrength',
    'netRentProfitability',
    'abilityToFillResidence',
  ];

  constructor(public gridkyService: EaGridkyService) {
    this.gridkyService.productChanged.subscribe(this.initMap.bind(this));
  }

  ngOnInit(): void {
    this.initMap();
    this.properties = this.getPropertyRating();
    this.detectDarkMode();
  }

  ngAfterViewInit() {
    const htmlElement = document.querySelector('html');
    const observer = new MutationObserver(() => {
      this.detectDarkMode();
    });
    observer.observe(htmlElement, {
      attributes: true,
      attributeFilter: ['class'],
    });
  }
  initMap() {
    if (!this.gridkyService.product) return;
    setTimeout(() => {
      this.mapOptions = {
        center: {
          lat: this.gridkyService.product.program.latitude,
          lng: this.gridkyService.product.program.longitude,
        },
        zoom: 18,
        disableDefaultUI: true,
        gestureHandling: 'none',
        styles: this.darkMode
          ? this.getDarkMapStyles()
          : this.getLightMapStyles(),
      };

      let map = this.mapOptions;
      this.marker = {
        map,
        position: {
          lng: this.gridkyService.product.program.longitude,
          lat: this.gridkyService.product.program.latitude,
        },
      };
      this.mapOptions = {
        center: {
          lng: this.gridkyService.product.program.longitude,
          lat: this.gridkyService.product.program.latitude,
        },
        zoom: 16,
        disableDefaultUI: true,
        gestureHandling: 'none',
      };
    }, 0);
  }

  detectDarkMode() {
    const htmlElement = document.querySelector('html');
    const isDarkMode = htmlElement.classList.contains('theme-dark');
    this.darkMode = isDarkMode;
    const mapStyles = isDarkMode
      ? this.getDarkMapStyles()
      : this.getLightMapStyles();
    if (this.map) {
      this.map.setOptions({ styles: mapStyles });
    }
  }

  getDarkMapStyles() {
    return [
      {
        elementType: 'geometry',
        stylers: [
          {
            color: '#1d2c4d',
          },
        ],
      },
      {
        elementType: 'labels.text.fill',
        stylers: [
          {
            color: '#8ec3b9',
          },
        ],
      },
      {
        elementType: 'labels.text.stroke',
        stylers: [
          {
            color: '#1a3646',
          },
        ],
      },
      {
        featureType: 'administrative.country',
        elementType: 'geometry.stroke',
        stylers: [
          {
            color: '#4b6878',
          },
        ],
      },
      {
        featureType: 'administrative.land_parcel',
        elementType: 'labels.text.fill',
        stylers: [
          {
            color: '#64779e',
          },
        ],
      },
      {
        featureType: 'administrative.province',
        elementType: 'geometry.stroke',
        stylers: [
          {
            color: '#4b6878',
          },
        ],
      },
      {
        featureType: 'landscape.man_made',
        elementType: 'geometry.stroke',
        stylers: [
          {
            color: '#334e87',
          },
        ],
      },
      {
        featureType: 'landscape.natural',
        elementType: 'geometry',
        stylers: [
          {
            color: '#023e58',
          },
        ],
      },
      {
        featureType: 'poi',
        elementType: 'geometry',
        stylers: [
          {
            color: '#283d6a',
          },
        ],
      },
      {
        featureType: 'poi',
        elementType: 'labels.text.fill',
        stylers: [
          {
            color: '#6f9ba5',
          },
        ],
      },
      {
        featureType: 'poi',
        elementType: 'labels.text.stroke',
        stylers: [
          {
            color: '#1d2c4d',
          },
        ],
      },
      {
        featureType: 'poi.park',
        elementType: 'geometry.fill',
        stylers: [
          {
            color: '#023e58',
          },
        ],
      },
      {
        featureType: 'poi.park',
        elementType: 'labels.text.fill',
        stylers: [
          {
            color: '#3C7680',
          },
        ],
      },
      {
        featureType: 'road',
        elementType: 'geometry',
        stylers: [
          {
            color: '#304a7d',
          },
        ],
      },
      {
        featureType: 'road',
        elementType: 'labels.text.fill',
        stylers: [
          {
            color: '#98a5be',
          },
        ],
      },
      {
        featureType: 'road',
        elementType: 'labels.text.stroke',
        stylers: [
          {
            color: '#1d2c4d',
          },
        ],
      },
      {
        featureType: 'road.highway',
        elementType: 'geometry',
        stylers: [
          {
            color: '#2c6675',
          },
        ],
      },
      {
        featureType: 'road.highway',
        elementType: 'geometry.stroke',
        stylers: [
          {
            color: '#255763',
          },
        ],
      },
      {
        featureType: 'road.highway',
        elementType: 'labels.text.fill',
        stylers: [
          {
            color: '#b0d5ce',
          },
        ],
      },
      {
        featureType: 'road.highway',
        elementType: 'labels.text.stroke',
        stylers: [
          {
            color: '#023e58',
          },
        ],
      },
      {
        featureType: 'transit',
        elementType: 'labels.text.fill',
        stylers: [
          {
            color: '#98a5be',
          },
        ],
      },
      {
        featureType: 'transit',
        elementType: 'labels.text.stroke',
        stylers: [
          {
            color: '#1d2c4d',
          },
        ],
      },
      {
        featureType: 'transit.line',
        elementType: 'geometry.fill',
        stylers: [
          {
            color: '#283d6a',
          },
        ],
      },
      {
        featureType: 'transit.station',
        elementType: 'geometry',
        stylers: [
          {
            color: '#3a4762',
          },
        ],
      },
      {
        featureType: 'water',
        elementType: 'geometry',
        stylers: [
          {
            color: '#0e1626',
          },
        ],
      },
      {
        featureType: 'water',
        elementType: 'labels.text.fill',
        stylers: [
          {
            color: '#4e6d70',
          },
        ],
      },
    ];
  }

  getLightMapStyles() {
    return [];
  }
  findRegex = new RegExp(/((?<prefix>\*\*)(?<text>.*?)(?<suffix>\*\*))/gm);

  formatHtml(html) {
    var res = html.replace(this.findRegex, function (match) {
      return '<b class="bold">' + match.slice(2, -2) + '</b>';
    });
    return res;
  }

  getPropertyRating() {
    const noteFieldTexts = {
      potentialCapitalGain: {
        title: 'Le potentiel de plus value',
        description:
          "Ce critère évalue le potentiel de valorisation du bien immobilier à long terme. Il se base sur l'analyse des tendances passées du marché immobilier dans la région et projette l'évolution des prix sur une période de 15 ans. Une note élevée indique un fort potentiel de plus-value.",
      },
      resaleEasiness: {
        title: 'La facilité de revente',
        description:
          "Ce critère mesure la facilité à trouver un acheteur potentiel pour le bien immobilier en cas de revente. Il prend en compte des facteurs tels que l'évolution démographique de la zone, l'attrait du bien (par exemple, une orientation favorable ou un étage élevé) et la demande sur le marché immobilier local.",
      },
      neighborhoodAttractivity: {
        title: 'L’attractivité du quartier',
        description:
          "Ce critère évalue l'attractivité globale de la zone où se situe le bien immobilier. Il prend en compte des éléments tels que l'accessibilité aux transports en commun, la présence de commerces, d'écoles et de services à proximité. Une note élevée indique un quartier dynamique et attractif.",
      },
      rentProfitability: {
        title: 'La rentabilité locative',
        description:
          "Ce critère évalue la rentabilité potentielle du bien immobilier en tant qu'investissement locatif. Il compare les loyers estimés que vous pourriez percevoir avec le coût d'achat du bien. Une note élevée indique une rentabilité locative favorable.",
      },
      rentalSecurity: {
        title: 'La sécurité locative',
        description:
          "Ce critère mesure le niveau de risque de non-location ou d'impayé de loyer pour le bien immobilier. Il prend en compte des facteurs tels que le taux de logements vacants dans le quartier, les incidents d'impayés fréquents et les indicateurs socio-économiques qui peuvent influencer la stabilité des locataires.",
      },
      taxPerformance: {
        title: 'La performance fiscale',
        description:
          'Ce critère évalue la performance fiscale du bien immobilier. Il prend en compte des éléments tels que les avantages fiscaux, les impôts locaux et les éventuelles charges fiscales spécifiques à la région. Une note élevée indique une bonne performance fiscale.',
      },

      rentalProfitabilityPostConsolidation: {
        title: 'La rentabilité locative après consolidation',
        description:
          'Ce critère évalue la rentabilité potentielle du bien immobilier après consolidation. Il prend en compte les coûts associés à la consolidation du bien (réparations, rénovations, etc.) et estime la rentabilité ajustée en conséquence. Une note élevée indique une bonne rentabilité après consolidation.',
      },

      managerStrength: {
        title: 'La force du gestionnaire',
        description:
          "Ce critère évalue la force et la compétence du gestionnaire du bien immobilier. Il prend en compte des éléments tels que l'expérience, la réputation et les compétences du gestionnaire. Une note élevée indique un gestionnaire fiable et efficace.",
      },

      netRentProfitability: {
        title: 'La rentabilité nette de location',
        description:
          "Ce critère évalue la rentabilité nette de la location du bien immobilier. Il prend en compte les coûts associés à la location tels que les charges, les frais de gestion et les dépenses d'entretien, afin d'estimer la rentabilité réelle. Une note élevée indique une bonne rentabilité nette.",
      },

      abilityToFillResidence: {
        title: 'La capacité à remplir la résidence',
        description:
          "Ce critère évalue la capacité du bien immobilier à être rapidement occupé par des locataires. Il prend en compte des facteurs tels que la demande sur le marché locatif, l'emplacement et les caractéristiques du bien qui peuvent influencer sa popularité auprès des locataires. Une note élevée indique une forte capacité à trouver des locataires.",
      },
    };

    const propertyRatings: PropertyRating[] = this.noteFieldNames
      .map(fieldName => {
        const rating = _.get(this.product, fieldName);
        const description = noteFieldTexts[fieldName].description || '';
        const title = noteFieldTexts[fieldName].title || '';
        return { fieldName, rating, description, title };
      })
      .filter(propertyRating => propertyRating.rating !== undefined);
    return propertyRatings;
  }
  get product() {
    return this.gridkyService.product ?? undefined;
  }
}
